module.exports = __webpack_public_path__ + "static/Super_0220_Kirsti_Louko_Liika_kiltteys_kuluttaa_voimat.04fe8b74.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Super_0220_Kirsti_Louko_Liika_kiltteys_kuluttaa_voimat.pdf
// module id = 456
// module chunks = 35783957827783